import React from 'react'
import Askquestionheader from '../../Component/askequestion/questionheader/Questionheader';
import Askquestionbody from '../../Component/askequestion/questionbody/Questionbody';
import Askquestionfooter from '../../Component/askequestion/questionfooter/Questionfooter';
import Toptxt from "../../Component/askequestion/questionbody/Toptext"

function FAQ() {
    return (
        <div>
            <Askquestionheader />
            <Toptxt />
            <Askquestionbody />
            <Askquestionfooter />
        </div>
    )
}

export default FAQ;
